if (typeof playBestSection !== 'function') {
    class playBestSection extends HTMLElement {
        constructor() {
            super();
            this.section = null;
        }

        connectedCallback() {
            this.section = this.querySelector('[data-section]');
            if (this.section) {
                this.observeSection();
            }
        }

        observeSection() {
            const observer = new IntersectionObserver(entries => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        this.section.classList.add('show');
                    } else {
                        this.section.classList.remove('show');
                    }
                });
            }, { threshold: 0.3 });

            observer.observe(this.section);
        }
    }

    if (typeof customElements.get('adrnl-play-best') === 'undefined') {
        customElements.define('adrnl-play-best', playBestSection);
    }
}
